import React, { useState } from "react";
import { FaCirclePlay } from "react-icons/fa6";
import { Container, H1_SIZE } from "../home/ui";
import { Eyebrow, BlueButton, edgeFade } from "./mobileUi";

// Hero artwork (two phones). On desktop (xl+) it sits as a background on the right side of the section;
// on mobile/tablet it shows below the text. Put the file at public/img/mobile-hero.jpg (or change the path).
// Until it exists, a simple placeholder blob is shown.
const heroImg = "/img/mobile-hero.jpg";

const MobileHero = () => {
  const [failed, setFailed] = useState(false);

  return (
    <section className="relative overflow-hidden bg-gradient-to-r from-white via-[#FAFBFF] to-[#F3F6FE] pb-[48px] pt-[110px] xl:flex xl:min-h-[min(38vw,720px)] xl:items-center xl:pb-[40px] xl:pt-[calc(clamp(76px,5.83vw,112px)+20px)]">
      {!failed && (
        <img
          src={heroImg}
          onError={() => setFailed(true)}
          alt=""
          aria-hidden="true"
          className="pointer-events-none absolute right-[2vw] top-[calc(clamp(76px,5.83vw,112px)+4px)] hidden h-[min(33vw,620px)] w-auto max-w-none select-none xl:block"
          style={edgeFade}
        />
      )}
      {failed && (
        <div className="pointer-events-none absolute right-[10vw] top-1/2 hidden h-[24vw] w-[30vw] -translate-y-1/3 rounded-[45%_55%_50%_50%/55%_45%_55%_45%] bg-[#DCE6FF] xl:block" />
      )}

      <Container className="relative grid w-full max-w-[1900px] items-center gap-[32px] xl:grid-cols-[minmax(0,46%)_1fr] xl:pl-[clamp(32px,4.375vw,84px)] xl:pr-[clamp(24px,3.125vw,60px)]">
        <div className="m-hero">
          <Eyebrow>Mobile App Development</Eyebrow>
          <h1 className={`mt-[18px] font-bold tracking-tight text-[#0F1B4C] ${H1_SIZE}`}>
            Powerful Mobile Apps
            {" "}<br />
            for a <span className="text-[#3D5AFE]">Smarter Tomorrow</span>
          </h1>
          <p className="mt-[18px] max-w-[620px] text-[16px] leading-[1.65] text-slate-600 sm:text-[17px] xl:text-[clamp(15px,1.05vw,18px)]">
            At Datametricks, we build high-performing, scalable and user-centric mobile applications that turn your ideas
            into impactful digital products. From concept to launch, we craft apps that engage users and accelerate your
            business growth.
          </p>
          <div className="m-btns mt-[30px] flex flex-wrap items-center gap-[28px]">
            <BlueButton href="/contact-us">Get a Free Consultation</BlueButton>
            {/* Plain text link on tablet/desktop; on phones it becomes an outlined pill next to the blue button. */}
            <a
              href="/our-completed-projects"
              className="inline-flex items-center gap-[10px] text-[15.5px] font-medium text-[#0F1B4C] transition hover:text-[#3D5AFE] max-sm:h-[50px] max-sm:rounded-full max-sm:bg-white max-sm:px-[26px] max-sm:text-[#2B44D8] max-sm:[border:1.5px_solid_#8EA2FF]"
            >
              <FaCirclePlay className="text-[22px] text-[#3D5AFE] max-sm:hidden" />
              Explore Our Work
            </a>
          </div>
        </div>

        {/* Mobile / tablet: artwork below the text */}
        {!failed && (
          <div className="flex justify-center xl:hidden">
            <img
              src={heroImg}
              onError={() => setFailed(true)}
              alt="Two smartphones showing a modern mobile app"
              className="h-auto w-full max-w-[560px] select-none object-contain"
              style={edgeFade}
            />
          </div>
        )}
      </Container>
    </section>
  );
};

export default MobileHero;
